import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Input, Button, ButtonToolbar, Modal} from 'react-bootstrap'
import Icon from '../../core/components/Icon'
import {sendAssociateUserWithAgencyCmd, sendDissociateUserFromAgencyCmd, loadUserStream} from '../actions'
import i18n from '../i18n'
import style from './AssociateDissociateUserFromAgencyModal.less'

function agencyFilter(agencies) {
    return (agency) => {
        return agencies.find((a) => a.uid == agency.uid) == null
    }
}

class AssociateDissociateUserFromAgencyModal extends Component {

    static propTypes = {
        user: PropTypes.object.isRequired,
        onHide: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    componentWillMount() {
        const {user, companyAgencies} = this.props

        const agencies = companyAgencies.filter(agencyFilter(user.managedAgencies))
        this.setState({agencies})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.user != this.props.user
            || nextProps.companyAgencies != this.props.companyAgencies) {
            const {user, companyAgencies} = nextProps
            
            const agencies = companyAgencies.filter(agencyFilter(user.managedAgencies))
            this.setState({agencies})
        }
    }

    _sendAssociateCmd(event, agencyId) {
        const {dispatch, user, onHide} = this.props
        
        event.preventDefault()
        dispatch(sendAssociateUserWithAgencyCmd(user.uid, agencyId)).then(() => {
            return dispatch(loadUserStream())
        }).then(() => {
            this.setState({selectedAgencyId: null})
        }).catch(() => {
            this.setState({selectedAgencyId: null})
        })
    }

    _sendDissociateCmd(event, agency) {
        const {dispatch, user} = this.props

        event.preventDefault()
        dispatch(sendDissociateUserFromAgencyCmd(user.uid, agency.uid)).then(() => {
            return dispatch(loadUserStream())
        })
    }

    render() {
        const {dispatch, user, companyAgencies, onHide, ...others} = this.props
        const {agencies, selectedAgencyId} = this.state

        const agencyField = {
            value: selectedAgencyId || '',
            onChange: (event) => {
                const selectedAgencyId = event.target.value
                this.setState({selectedAgencyId})
                this._sendAssociateCmd(event, selectedAgencyId)
            }
        }

        return (
            <Modal
                onHide={onHide}
                {...others}>
                <Modal.Header>
                    <Modal.Title>{i18n.associateDissociateAgencies}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ul className={style.agencyGroup}>
                        {user.managedAgencies.map((agency) => (
                            <li key={agency.uid}>
                                <a
                                    href=''
                                    className={style.dissociate}
                                    onClick={(e) => this._sendDissociateCmd(e, agency)}>
                                    <Icon icon='minus' size='xs' />
                                </a>
                                <p>{agency.label}</p>
                            </li>
                        ))}
                    </ul>
                    <form>
                        <Input
                            type='select'
                            name='agency'
                            {...agencyField}>
                            <option value=''>{i18n.addAgency}</option>
                            {agencies.map((agency, index) => (
                                <option
                                    key={index}
                                    value={agency.uid}>
                                    {agency.label}
                                </option>
                            ))}
                        </Input>
                    </form>
                    <ButtonToolbar>
                        <Button
                            bsSize='large'
                            onClick={onHide}>
                            {i18n.cancel}
                        </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        )
    }
}

AssociateDissociateUserFromAgencyModal = connect((state) => ({
    companyAgencies: state.company.companyAgencies
}))(AssociateDissociateUserFromAgencyModal)

export default AssociateDissociateUserFromAgencyModal


// WEBPACK FOOTER //
// ./lib/company/components/AssociateDissociateUserFromAgencyModal.js